export default __webpack_public_path__ + "a91f0c1f114c23a811106a7b29576564.svg";